import React, {
    createContext, useCallback, useContext, useLayoutEffect, useMemo, useState
} from 'react';
import PropTypes from 'prop-types';

import ConnectedSessionExpiredBanner from './SessionExpiredBanner';





export const SessionBannerSlotContext = createContext({
    claimed: false,
    claimSlot: () => {},
    releaseSlot: () => {}
});

export const SessionBannerSlotProvider = ({ children }) => {
    const [claimCount, setClaimCount] = useState(0);

    const claimSlot = useCallback(() => setClaimCount(count => count + 1), []);
    const releaseSlot = useCallback(() => setClaimCount(count => Math.max(count - 1, 0)), []);

    const value = useMemo(() => ({
        claimed: claimCount > 0,
        claimSlot,
        releaseSlot
    }), [claimCount, claimSlot, releaseSlot]);

    return (
        <SessionBannerSlotContext.Provider value={value}>
            {children}
        </SessionBannerSlotContext.Provider>
    );
};

SessionBannerSlotProvider.propTypes = {
    children: PropTypes.node.isRequired
};




export const SessionBannerSlot = () => {
    const { claimSlot, releaseSlot } = useContext(SessionBannerSlotContext);

    useLayoutEffect(() => {
        claimSlot();
        return releaseSlot;
    }, [claimSlot, releaseSlot]);

    return <ConnectedSessionExpiredBanner />;
};


export const SessionBannerDefaultSlot = () => {
    const { claimed } = useContext(SessionBannerSlotContext);

    return claimed ? null : <ConnectedSessionExpiredBanner />;
};

export default SessionBannerSlot;
